// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"c4e2a98e","255":"ff483ae0","351":"221af1c5","494":"78f320eb","605":"43d1555d","865":"fd38674b","916":"7b80a4ef"}[chunkId] + ".chunk.js";
};